import { format, parse } from 'date-fns';

const DATE_ONLY_FORMAT = 'yyyy-MM-dd';

export function formatDateOnly(date: Date): string {
  return format(date, DATE_ONLY_FORMAT);
}

export function parseDateOnly(value: string | null | undefined, referenceDate: Date = new Date()): Date {
  if (!value) {
    return new Date(referenceDate);
  }
  return parse(value, DATE_ONLY_FORMAT, referenceDate);
}

export function getTodayDateString(): string {
  return formatDateOnly(new Date());
}
